const Settings =  {
    app_version: '1.4.3',
    push_time: '19.03.2026, 09:50'
}
export default Settings
